export interface PollingOptions<T> {
  request: () => Promise<T>;
  onValue: (value: T) => void;
  onError: (error: unknown) => void;
  shouldContinue: (value: T) => boolean;
  delayMs: number;
}

export function startPolling<T>(options: PollingOptions<T>): () => void {
  let stopped = false;
  let timer: ReturnType<typeof setTimeout> | undefined;

  const schedule = () => {
    timer = globalThis.setTimeout(() => void poll(), options.delayMs);
  };
  const poll = async () => {
    try {
      const value = await options.request();
      if (stopped) return;
      options.onValue(value);
      if (options.shouldContinue(value)) schedule();
    } catch (error) {
      if (stopped) return;
      options.onError(error);
      schedule();
    }
  };

  schedule();
  return () => {
    stopped = true;
    if (timer !== undefined) globalThis.clearTimeout(timer);
  };
}
